@if (editable) {
  <div #clockIconDropdown="ngbDropdown" [autoClose]="'outside'" [container]="dropdownContainer" class="dropdown topbar-head-dropdown header-item topbar-clock-icon" ngbDropdown>
    <button
      aria-expanded="false"
      aria-haspopup="true"
      class="btn topbar-clock-icon-btn topbar-clock-icon-btn-multi"
      ngbDropdownToggle
      type="button"
    >
      <ng-container *ngTemplateOutlet="chipContent"></ng-container>
    </button>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end p-0 topbar-clock-icon-menu">
      <div class="topbar-clock-icon-menu-header d-flex align-items-center p-3 border-bottom">
        <span class="topbar-clock-icon-globe me-2">
          <i class="bi bi-globe2"></i>
        </span>
        <div class="flex-grow-1">
          <h6 class="m-0 fs-15 fw-semibold">World Clock</h6>
          <span class="fs-12 text-muted">Current time across global regions</span>
        </div>
      </div>
      <div class="topbar-clock-icon-menu-list p-2">
        @for (zone of allZones; track zone.key) {
          <button
            class="topbar-clock-icon-row d-flex align-items-center p-2 rounded w-100"
            [class.active]="isZoneChecked(zone.key)"
            type="button"
            (click)="toggleZoneCheck(zone.key, $event)"
          >
              <input
                [checked]="isZoneChecked(zone.key)"
                class="form-check-input topbar-clock-icon-check me-2"
                type="checkbox"     
                (click)="$event.stopPropagation()"
                (change)="toggleZoneCheck(zone.key)"
              >
              @if (hideFlags) {
                <span class="topbar-clock-icon-flag topbar-clock-icon-flag-text me-2">{{ ticks[zone.key]?.label }}</span>
              } @else if (zone.flagImg) {
                <span class="topbar-clock-icon-flag topbar-clock-icon-flag-img me-2"><img [src]="zone.flagImg" [alt]="zone.flagAlt ?? ''"></span>
              } @else {
                <span class="topbar-clock-icon-flag me-2"><i [class]="zone.flagIcon"></i></span>
              }
              <div class="flex-grow-1 text-start">
                <div class="fw-semibold fs-13">
                  @if (zone.key === 'local') {
                    LOCAL - Your timezone
                  } @else {
                    {{ zone.getTipTitle() }}
                  }
                </div>
                <div class="text-muted fs-11">
                  @if (zone.key === 'local') {
                    {{ localTimezoneLabel }}
                  } @else {
                    {{ zone.tipSub }}
                  }
                </div>
              </div>
              <span class="topbar-clock-icon-row-time fw-semibold">{{ ticks[zone.key]?.iconTime }}</span>
          </button>
        }
      </div>
      <div class="topbar-clock-icon-menu-footer p-2 border-top d-flex gap-2">
        @if (showBarOptionInPicker) {
          <button type="button" class="btn btn-primary flex-grow-1 d-flex align-items-center justify-content-center" (click)="showBarClicked(); clockIconDropdown.close()">
            <span class="fw-semibold">Show Clockbar</span>
          </button>
        }
        <button type="button" class="btn btn-secondary flex-grow-1 d-flex align-items-center justify-content-center" (click)="toggleAllZones(); clockIconDropdown.close()">
          <span class="fw-semibold">{{ allZonesChecked ? 'Local' : 'All' }}</span>
        </button>
        <button type="button" class="btn btn-success flex-grow-1 d-flex align-items-center justify-content-center" (click)="clockIconDropdown.close()">
          <span class="fw-semibold">Done</span>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="topbar-clock-icon">
    <span class="btn topbar-clock-icon-btn topbar-clock-icon-btn-multi" role="group">
      <ng-container *ngTemplateOutlet="chipContent"></ng-container>
    </span>
  </div>
}

<ng-template #chipContent>
  @for (zone of selectedZones; track zone.key; let isLast = $last) {
    <ng-template #chipTip>
      <div class="fw-semibold">{{ zone.getTipTitle() }}</div>
      @if (zone.tipSub) {
        <div class="fs-11 opacity-75">{{ zone.tipSub }}</div>
      }
    </ng-template>
    <span
      class="topbar-clock-icon-chip"
      [ngbTooltip]="showTooltips ? chipTip : null"
      placement="bottom"
      tooltipClass="custom-tooltip-success custom-tooltip-success-nowrap"
    >
      @if (!hideFlags) {
        @if (zone.flagImg) {
          <span class="topbar-clock-icon-flag topbar-clock-icon-flag-img"><img [src]="zone.flagImg" [alt]="zone.flagAlt ?? ''"></span>
        } @else {
          <span class="topbar-clock-icon-flag"><i [class]="zone.flagIcon"></i></span>
        }
      }
      <span class="topbar-clock-icon-text">
        <span class="topbar-clock-icon-label">{{ ticks[zone.key]?.label }}</span>
        <span class="topbar-clock-icon-time">{{ compactTime(zone.key, isLast) }}</span>
      </span>
    </span>
  }
</ng-template>
